
<div class="input-search rounded shadow  pe-auto">
    <input #searchInput type="text" placeholder="Search" [value]="(value)?value:''" (keyup.enter)="submit(searchInput.value)" />
    <button type="button" class="search-btn" (click)="submit(searchInput.value)" aria-label="Search">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.398 1.398h-.001l3.85 3.85a1 1 0 0 0 1.414-1.414l-3.85-3.85h-.015zM12 6.5a5.5 5.5 0 1 1-11 0a5.5 5.5 0 0 1 11 0"/>
        </svg>
    </button>
    </div>
